<template>
  <div :class="$style.wrap">
    <div
      ref="scrollContainer"
      :class="$style['scroll-container']"
      :style="{ width, height }"
      @scroll.passive="toggleShadow">
      <slot/>
      <template v-if="useShadow">
        <span :class="[$style['shadow-top'], shadow.top && $style['is-active']]"/>
        <span :class="[$style['shadow-right'], shadow.right && $style['is-active']]"/>
        <span :class="[$style['shadow-bottom'], shadow.bottom && $style['is-active']]"/>
        <span :class="[$style['shadow-left'], shadow.left && $style['is-active']]"/>
      </template>
    </div>
  </div>
</template>
<script>
function newResizeObserver(callback) {
  // Пропускаем эту функцию для браузеров, которые
  // не поддерживает ResizeObserver.
  // https://caniuse.com/#search=resizeobserver
  if (typeof ResizeObserver === 'undefined') { return }

  return new ResizeObserver(e => e.map(callback))
}

export default {
  name: 'scrollShadow',
  data() {
    return {
      width: undefined,
      height: undefined,
      shadow: {
        top: false,
        right: false,
        bottom: false,
        left: false
      }
    }
  },
  mounted() {
    // Проверяем, нужны ли тени после изменения размера элемента..
    const scrollContainerObserver = newResizeObserver(this.toggleShadow)
    if (scrollContainerObserver) {
      scrollContainerObserver.observe(this.$refs.scrollContainer)
      // Очищаем при уничтожении компонента.
      this.$once('hook:destroyed', () => scrollContainerObserver.disconnect())
    }

    // Пересчитываем размеров контейнера при изменении размера оболочки.
    const wrapObserver = newResizeObserver(this.calcDimensions)
    if (wrapObserver) {
      wrapObserver.observe(this.$el)
      // Очищаем при уничтожении компонента.
      this.$once('hook:destroyed', () => wrapObserver.disconnect())
    }
  },
  methods: {
    async calcDimensions() {
      this.width = undefined
      this.height = undefined
      await this.$nextTick()

      if (this.shadowWidth) {
        this.width = `${this.$el.clientWidth}px`
      }
      if (this.shadowHeight) {
        this.height = `${this.$el.clientHeight}px`
      }
    },
    toggleShadow() {
      const hasHorizontalScrollbar =
        this.$refs.scrollContainer.clientWidth <
        this.$refs.scrollContainer.scrollWidth
      const hasVerticalScrollbar =
        this.$refs.scrollContainer.clientHeight <
        this.$refs.scrollContainer.scrollHeight

      const scrolledFromLeft =
        this.$refs.scrollContainer.offsetWidth +
        this.$refs.scrollContainer.scrollLeft
      const scrolledFromTop =
        this.$refs.scrollContainer.offsetHeight +
        this.$refs.scrollContainer.scrollTop

      const scrolledToTop = this.$refs.scrollContainer.scrollTop - this.paddingDelta === 0
      const scrolledToRight = scrolledFromLeft + this.paddingDelta >= this.$refs.scrollContainer.scrollWidth
      const scrolledToBottom = scrolledFromTop + this.paddingDelta >= this.$refs.scrollContainer.scrollHeight
      const scrolledToLeft = this.$refs.scrollContainer.scrollLeft - this.paddingDelta === 0
      if (scrolledToBottom) {
        this.$emit('scrolledToBottom')
      }
      if (scrolledToTop) {
        this.$emit('scrolledToTop')
      }

      this.shadow.top = hasVerticalScrollbar && !scrolledToTop
      this.shadow.right = hasHorizontalScrollbar && !scrolledToRight
      this.shadow.bottom = hasVerticalScrollbar && !scrolledToBottom
      this.shadow.left = hasHorizontalScrollbar && !scrolledToLeft
    },
  },
  props: {
    useShadow: {
      type: Boolean,
      default: true
    },
    shadowWidth: {
      type: Boolean,
      default: true
    },
    shadowHeight: {
      type: Boolean,
      default: true
    },
    paddingDelta: {
      type: Number,
      default: 0
    }
  }
}
</script>
<style lang="scss" module>
.wrap {
  overflow: hidden;
  position: relative;
}

.scroll-container {
  overflow: auto;
}

.shadow-top,
.shadow-right,
.shadow-bottom,
.shadow-left {
  position: absolute;
  /*border-radius: 6em;*/
  opacity: 0;
  transition: opacity 0.2s;
  pointer-events: none;
}

.shadow-top,
.shadow-bottom {
  right: 0;
  left: 0;
  height: 1em;
  border-top-right-radius: 0;
  border-top-left-radius: 0;
  background-image: linear-gradient(rgb(0 0 0 / 15%) 0%, rgba(255, 255, 255, 0) 100%);
}

.shadow-top {
  top: 0;
}

.shadow-bottom {
  bottom: 0;
  transform: rotate(180deg);
}

.shadow-right,
.shadow-left {
  top: 0;
  bottom: 0;
  width: 1em;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  background-image: linear-gradient(90deg, rgba(#555, 0.1) 0%, rgba(#FFF, 0) 100%);
}

.shadow-right {
  right: 0;
  transform: rotate(180deg);
}

.shadow-left {
  left: 0;
}

.is-active {
  opacity: 1;
}
</style>
